export const cleanMarkdown = (markdown: string): string => {
  // Trim trailing newlines
  let cleaned = markdown.replace(/\n+$/, '');

  // Remove any trailing empty headings (subsequent to the first heading)
  cleaned = cleaned.replace(/\n\s*#+\s*$/, '');

  // Handle the very end of the document if it ends with a list marker
  if (/(?:^|\n)(\s*(?:[-*+]\s+\[[ xX]\]|[-*+]|\d+[.)]))\s*$/.test(cleaned)) {
    // It ends with a list marker, so ensure there is exactly one space after it
    cleaned = cleaned.replace(/\s*$/, ' ');
  } else {
    // Otherwise, normal trim of trailing whitespace
    cleaned = cleaned.replace(/\s+$/, '');
  }

  return cleaned;
};
